<template>
  <v-app>
    <!--============-->
    <!-- NAV Drawer -->
    <!--============-->
    <v-navigation-drawer v-show="intern" app v-model="show_drawer" mobile-breakpoint="sm"
                         :permanent="false"
                         :temporary="$vuetify.breakpoint.smAndDown">
      <!--                         :permanent="drawerIsPermanent"-->
      <div class="d-flex flex-column" style="height: 100%;">
        <div class="d-block">
        <v-list-item @click="show_drawer=false">
          <!--        <v-list-item-icon>-->
          <!--          <v-img :src="require('@/assets/rocket.svg')"></v-img>-->
          <!--        </v-list-item-icon>-->
          <v-list-item-content class="ml-3">
            <v-list-item-title class="text-button" style="position: relative;">
              <v-img :src="require('@/assets/aimz.svg')" class="mr-5 mb-3"></v-img>
              <div class="blue--text" style="position: absolute; top: -2px; right: 0">
                {{productTier}}
              </div>
            </v-list-item-title>
            <v-list-item-subtitle class="dunkelblau--text">
              {{ user.email }}
              <template v-if="is_guest">
                <br>({{ (guest_user || {}).Email }})
              </template>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item v-for="item in nav" v-if="is_authorized(item)" :key="item.title" @click="item.click && onItemClick(item)"
                     :to="item.to" link color="accent">
          <v-list-item-icon class="mr-3">
            <v-icon color="dunkelblau">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.title }}
              <pro v-if="isFree && item.free==false"/>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group color="accent">
          <template v-slot:activator>
            <v-list-item-icon class="mr-3">
              <v-icon class="mr-0" color="dunkelblau">mdi-cog</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Einstellungen</v-list-item-title>
          </template>
          <v-divider></v-divider>
          <v-list-item v-for="item in nav_settings" v-if="is_authorized(item)" :key="item.title" @click="item.click && onItemClick(item)"
                       :to="item.to" link color="accent">
            <v-list-item-icon class="mx-3">
              <v-icon color="dunkelblau">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-divider></v-divider>
        <!-- Login-->
        <v-list-item v-if="!is_logged_in" link to="/login">
          <v-list-item-icon class="mr-3">
            <v-icon color="dunkelblau">mdi-rocket-launch</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Login</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- Logout-->
        <v-list-item v-if="is_logged_in" link @click="logout">
          <v-list-item-icon class="mr-3">
            <v-icon color="dunkelblau">mdi-logout-variant</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ is_guest ? "Gast-Logout" : "Logout" }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <template v-if="(is_super_user || is_admin)">
          <div class="mt-10">
            <v-list-item v-for="item in nav_su" v-if="is_authorized(item)" :key="item.title" @click="item.click && onItemClick(item)" :to="item.to" link
                         dense>
              <v-list-item-icon>
                <v-icon color="secondary">{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
        </template>
        </div>
        <div class="d-block" style="flex: 1 1 auto;">
        </div>
        <div class="d-flex mt-auto grey--text body-2 ml-3">
          <small>
            <router-link class="grey--text" to="/impressum">Impressum</router-link>,
            <router-link class="grey--text" to="/agb">AGB</router-link>,
            <router-link class="grey--text" to="/datenschutz">Datenschutz</router-link>
          </small>
        </div>
      </div>
    </v-navigation-drawer>

    <!--============-->
    <!-- APP Bar -->
    <!--============-->
    <v-app-bar v-show="intern" app dense color="dunkelblau" >
      <v-btn icon color="white" @click="show_drawer=!show_drawer" class="mr-sm-n12">
        <v-icon color="gelb">mdi-menu</v-icon>
      </v-btn>
      <v-divider v-if="$vuetify.breakpoint.smAndUp"/>
      <v-btn class="ml-n2 ml-sm-0" v-if="is_logged_in" icon color="white" @click="goto('/dashboard')">
        <v-icon color="gelb">mdi-monitor-dashboard</v-icon>
      </v-btn>
      <v-btn class="ml-n2 ml-sm-0" v-if="is_logged_in && isDirector" icon color="white" @click="goto('/team_dashboard')">
        <v-icon color="gelb">mdi-sitemap</v-icon>
      </v-btn>
      <v-btn class="ml-n2 ml-sm-0" v-if="is_logged_in && isDirector" icon color="white" @click="goto('/team_leaderboard')">
        <v-icon color="gelb">mdi-trophy</v-icon>
      </v-btn>
      <v-btn class="ml-n2 ml-sm-0" v-if="is_logged_in" icon color="white" @click="goto('/eingabe')">
        <v-icon color="gelb">mdi-flag</v-icon>
      </v-btn>
      <v-btn class="ml-n2 ml-sm-0" v-if="is_logged_in" icon color="white" @click="goto('/stoppuhr')">
        <v-icon color="gelb">mdi-timer-outline</v-icon>
      </v-btn>
      <v-btn class="ml-n2 ml-sm-0" v-if="is_logged_in" icon color="white" @click="goto('/counters')">
        <v-icon color="gelb">mdi-counter</v-icon>
      </v-btn>
      <v-btn class="ml-n2 ml-sm-0" v-if="is_logged_in" icon color="white" @click="goto('/achievements')">
        <v-icon color="gelb">mdi-trophy</v-icon>
      </v-btn>
      <EingabeStreak v-if="is_logged_in" class="ml-sm-2"/>
      <v-divider v-if="$vuetify.breakpoint.smAndUp"/>
      <v-btn v-if="!is_logged_in || $route.path=='/'" icon color="white" to="/login">
        <v-icon color="gelb">mdi-rocket-launch</v-icon>
      </v-btn>
      <v-alert v-if="maintenance" type="info" class="mx-auto mt-3" style="max-width: 400px;">Eine Wartung ist im
        Gange. Bitte versuchen Sie es später nochmal.
      </v-alert>
    </v-app-bar>

    <!-- Sizes your content based upon application components -->
    <!--    <v-main app class="pa-0 ma-0">-->
    <!-- If using vue-router -->
    <router-view></router-view>
    <!--    </v-main>-->

    <!--===========================-->
    <!--snackbar                   -->
    <!--===========================-->
    <v-snackbar v-model="snackbar" class="mt-10" top right :timeout="snackbar_timeout" :color="snackbar_color"
                multi-line>
      {{ snackbar_text }}
    </v-snackbar>

    <!--===========================-->
    <!--ask generic question dialog-->
    <!--===========================-->
    <v-dialog v-model="askDialogOpen" persistent max-width="500px">
      <v-card>
        <v-card-title>{{ askDialogInfo.title }}</v-card-title>
        <v-card-text class="body-1 black--text">
          <div v-html="askDialogInfo.question">
          </div>
          <v-select v-if="askDialogInfo.options" :items="askDialogInfo.options"
                    v-model="askDialog_selectedOption">
          </v-select>
          <!--<v-divider></v-divider>-->
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <div class="ma-2 mt-0">
            <v-btn v-if="askDialogInfo.yes_button" color="primary" dark @click="onAskYes">
              {{ askDialogInfo.yes_button }}
            </v-btn>
            <v-btn v-if="askDialogInfo.cancel_button" color="grey lighten-2" class="ml-3" @click="onAskCancel">
              {{ askDialogInfo.cancel_button }}
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--===========================-->
    <!--pw change dialog-->
    <!--===========================-->
    <v-dialog v-model="pwChangeDlg" max-width="500px" persistent>
      <change-password @close="pwChangeDlg=false"/>
    </v-dialog>

  </v-app>
</template>

<script>
import Vue from 'vue';
import Lockr from 'lockr';
import {v4 as new_guid} from 'uuid';
import UserLib from "@/components/UserLib";
import ChangePassword from "@/components/ChangePassword";
import {DateTime} from "luxon";
import {formatDatum} from "@/reusable/date_and_time";
import EingabeStreak from "@/views/EingabeStreak";
import Pro from "@/components/Pro";

Lockr.prefix = 'DYL_';

export default {
  name: 'App',
  components: { ChangePassword, EingabeStreak, Pro },
  data: () => ({
        show_drawer: false,
        nav: [
          {icon: 'mdi-monitor-dashboard', title: 'Dashboard', to: '/dashboard'},
          {icon: 'mdi-sitemap', title: 'Team-Dashboard', to: '/team_dashboard', director:true },
          {icon: 'mdi-trophy', title: 'Leaderboard', to: '/team_leaderboard', director:true },
          {icon: 'mdi-flag', title: 'Eingabe', to: '/eingabe'},
          {icon: 'mdi-timer-outline', title: 'Stoppuhr', to: '/stoppuhr', free:false},
          {icon: 'mdi-counter', title: 'Zähler', to: '/counters', free:false},
          {icon: 'mdi-trophy', title: 'Leistungen', to: '/achievements'},
          {icon: 'mdi-script-text-outline', title: 'Wochenbericht', to: '/report'},
          {icon: 'mdi-book-open-variant', title: 'Workbook', to: '/workbook'},
          {icon: 'mdi-help-box', title: 'Hilfe', to: '/help'},
        ],
        nav_settings: [
          {icon: 'mdi-account-circle', title: 'Profil', to: '/profil'},
          {icon: 'mdi-fingerprint', title: 'Passwort ändern', click(self) {
            //console.log(self);
            self.pwChangeDlg=true; }},
          {icon: 'mdi-chart-donut', title: 'Lebenssäulen', to: '/erfolgsmatrix' },
          {icon: 'mdi-flag-plus', title: 'Aktivitäten', to: '/activities', },
          {icon: 'mdi-bullseye-arrow', title: 'Ziele', to: '/ziele', },
          {icon: 'mdi-account-group', title: 'Team', to: '/team_settings', teamLeader:true },
          {icon: 'mdi-email', title: 'Benachrichtigungen', to: '/notification_settings'},
          {icon: 'mdi-message', title: 'Feedback', to: '/feedback_settings', private:true},
        ],
        nav_su: [
          {icon: 'mdi-email', title: 'Email', to: '/service/email', suOrAdmin: true},
          {icon: 'mdi-message-alert', title: 'SMS', to: '/service/sms', suOrAdmin: true},
          {icon: 'mdi-account-circle', title: 'Benutzer', to: '/service/users', suOrAdmin: true},
          {icon: 'mdi-chart-bar', title: 'Stats', to: '/service/stats', su: true},
          {icon: 'mdi-message', title: 'Logs', to: '/service/logs', su: true},
          {icon: 'mdi-wrench', title: 'Wartung', to: '/service/maintenance', su: true},
        ],
        browserNotSupported: false,
        snackbar: false, // temporary alert
        snackbar_color: 'success',
        snackbar_text: '',
        snackbar_timeout: 3000,
        show_menu: false,
        askDialogOpen: false, // generic question dialog
        askDialogInfo: {}, // generic question dialog data
        pwChangeDlg: false, // passwort ändern dialog
        askDialog_selectedOption: null,
        maintenance: false,
        watchdog_timer: undefined,
      }
  ),
  created() {
    Vue.prototype.$app = this;
    this.$events.$on("notify", this.onShowNotification);
    this.$events.$on("error", this.onShowError);
    this.$events.$on("ask", info => this.onAsk(info));
    this.$events.$on("check_maintenance", this.onCheckMaintenanceMode);
    // unpersist persistent state
    this.load("token");
    this.load("user");
  },
  mounted() {
    this.show_drawer = this.$vuetify.breakpoint.mdAndUp
    this.onCheckMaintenanceMode();
    this.watchdog_timer = setInterval(this.onCheckSession, 60000);
    console.log("this.user", this.user);
  },
  beforeDestroy() {
    clearInterval(this.watchdog_timer);
  },
  methods: {
    setIntern() {
      // called by routes of the internal site to make sure drawer and appbar are shown
      this.$store.commit("set", {key: "intern", value: true});
    },
    save(key, value) {
      // save to browser db and update reactive variable in app (persistent)
      Lockr.set(key, value);
      this.$store.commit("set", {key: key, value: value}); // <--- this allows to view the values in VUE developer plugin
      console.log("saved to Lockr: " + key, value);
    },
    set(key, value) {
      // set reactive variable in app and in store, (not persistent)
      this.$store.commit("set", {key: key, value: value}); // <--- this allows to view the values in VUE developer plugin
    },
    load(key) {
      // load saved value from browser db and update reactive variable in app
      var value = Lockr.get(key);
      this.$store.commit("set", {key: key, value: value}); // <--- this allows to view the values in VUE developer plugin
      console.log("loaded from Lockr: " + key, value);
      return value;
    },
    onShowNotification(text) {
      if (!text)
        return;
      this.snackbar_text = text;
      this.snackbar_color = "success";
      this.snackbar = true;
      this.snackbar_timeout = 3000;
    },
    onShowError(text) {
      this.snackbar_text = text;
      this.snackbar_color = "error";
      this.snackbar = true;
      this.snackbar_timeout = 10000;
    },
    onAsk(info) {
      this.askDialogInfo = info;
      this.askDialogOpen = true;
      if (info.options)
        this.askDialog_selectedOption = info.options.firstOrDefault();
    },
    onAskYes() {
      var yes = this.askDialogInfo.onYes;
      this.askDialogInfo.selected_option = this.askDialog_selectedOption;
      if (yes)
        yes(this.askDialogInfo);
      this.askDialogOpen = false;
    },
    onAskCancel() {
      var cancel = this.askDialogInfo.onCancel;
      if (cancel)
        cancel(this.askDialogInfo);
      this.askDialogOpen = false;
    },
    onCheckMaintenanceMode() {
      this.$backend.get_maintenance_mode({onSuccess: (mode) => this.maintenance = mode, no_notify: true});
    },
    async onCheckSession() {
      if (!this.is_logged_in)
        return;
      var user = await this.$backend.check_session({no_notify: true, onError: this.onSessionError});
      //console.log({user})
      if (user)
        this.set("user", user);
    },
    onSessionError(data) {
      console.log("onSessionError", data);
      if (data && data.startsWith("500")) {
        this.$events.$emit("error", "Keine Verbindung zum Server!")
        clearInterval(this.watchdog_timer);
        return;
      }
      this.logout();
    },
    onLogin(token, user, guest, guest_user) {
      this.save("token", token);
      this.save("user", user);
      this.save("guest", guest);
      this.save("guest_user", guest_user);
    },
    logout() {
      if (this.is_guest) {
        this.gast_logout();
        return;
      }
      this.$backend.logout();
      this.$router.replace("/");
      this.save("token", undefined);
      this.save("user", {name: "Not logged in", email: "not@logged.in", su: false});
      this.$store.commit("set", {key: "intern", value: false});
    },
    async gast_logout() {
      if (!this.is_guest)
        return;
      var data = await this.$backend.gast_logout();
      if (!data) {
        this.$events.$emit("error", "Gast-Logout failed, got no data.")
        return;
      }
      this.$app.onLogin(data.token, data.user, data.guest, data.guest_user);
      this.error = false;
      this.$router.go(-1000);
      this.$router.replace('/lobby')
      this.$events.$emit("update_streak");
    },
    is_authorized(item) {
      // if (this.is_super_user && !item.teamLeader && !item.director)
      //   return true;
      if (item.teamLeader && !this.isTeamLeader)
        return false;
      if (item.private && !this.isPrivateUser)
        return false;
      if (item.director && !(this.isDirector))
        return false;
      if (item.privateOrDirector && !(this.isPrivateUser || this.isDirector))
        return false;
      if (item.su && !this.is_super_user)
        return false;
      if (item.suOrAdmin && !(this.is_super_user||this.is_admin))
        return false;
      return true;
    },
    goto(route) {
      if (this.$route.path == route)
        return;
      this.$router.replace(route);
    },
    // erfolgsmatrix
    getBereichName(bid) {
      var b=this.bereiche.filter(x=>x.bid===bid)[0];
      if (!b)
        return false;
      return b.name;
    },
    isBereichShown(bid) {
      var b=this.bereiche.filter(x=>x.bid===bid)[0];
      if (!b)
        return false;
      return !b.ignore;
    },
    backdropClick() {
      //console.log("click outside drawer!");
      this.show_drawer=false;
    },
    onItemClick(item) {
      var self=this.$app;
      console.log({item, self})
      item.click(self);
    },
    formatDatum(date) {
      if (!date)
        return "";
      return formatDatum(date);
    },
  },
  computed: {
    is_logged_in() {
      return !!this.$store.state.token;
    },
    user() {
      return (this.$store.state.user || {});
    },
    is_guest() {
      return (this.$store.state.guest || false);
    },
    guest_user() {
      return (this.$store.state.guest_user || {});
    },
    is_super_user() {
      // super user is the highest honor, usually reserved for devs
      return !!(this.user).su;
    },
    is_admin() {
      // admins can configure
      return ((this.user || {}).group === UserLib.GroupAdmin);
    },
    mobile() {
      return this.$vuetify.breakpoint.xs;
    },
    desktop() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
    intern() {
      return this.$store.state.intern;
    },
    drawerIsPermanent() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
    productName() {
      var prod = this.user.product;
      return UserLib.getProductName(prod);
    },
    isPrivateUser() {
      var prod = this.user.product;
      return (prod === UserLib.ProductPrivateUser);
    },
    isTeamLeader() {
      var prod = this.user.product;
      var group = this.user.group;
      return (prod === UserLib.ProductSalesTeam && (group===UserLib.GroupTeamLeader||group===UserLib.GroupDirector));
    },
    isDirector() {
      var prod = this.user.product;
      var group = this.user.group;
      return (prod === UserLib.ProductSalesTeam && group===UserLib.GroupDirector);
    },
    isTeamMember() {
      var prod = this.user.product;
      var group = this.user.group;
      return (prod === UserLib.ProductSalesTeam && group===UserLib.GroupDefault);
    },
    isTeamDashboard() {
      return this.user.product===UserLib.ProductSalesTeam;
    },
    emx() {
      return (this.user||{}).erfolgsmatrix||{};
    },
    bereiche() {
      var allowedNumB= this.isTeamDashboard ? 10 : UserLib.numBereiche( this.user.productId);
      console.log("Allowed bereiche:", allowedNumB)
      var bereiche= this.emx.bereiche.filter(x=>!x.ignore)||[];
      if (bereiche.length > allowedNumB)
        return bereiche.slice(0, allowedNumB);
      return bereiche;
    },
    productTier() {
      return UserLib.getAboName(this.user.productId);
    },
    isFree() {
      if (this.isTeamDashboard)
        return false;
      if (!this.user.productId)
        return true;
      return this.user.productId === UserLib.AboFree;
    },
    isSilver() {
      if (this.isTeamDashboard)
        return false;
      return this.user.productId === UserLib.AboSilver;
    },
    isGold() {
      if (this.isTeamDashboard)
        return true;
      return this.user.productId === UserLib.AboGold;
    },
    expirationInfo() {
      if (this.user.plan==="test")
        return "(läuft nicht ab / Tester)"
      if (!this.isFree)
        return "";
      var date = UserLib.getExpirationDate(this.user);
      if (DateTime.fromJSDate(new Date(date)) < DateTime.fromJSDate(new Date(Date.now())))
        return `(abgelaufen am ${this.formatDatum(date)})`;
      return `(bis ${this.formatDatum(date)})`;
    },
    isExpired() {
      if (this.user.plan==="test")
        return false;
      if (this.user.plan!=="trial")
        return false;
      if (this.user.plan==="blocked")
        return true;
      if (this.user.plan==="trial" && this.expirationInfo.includes("abgelaufen"))
        return true;
    }
  },
  watch: {
    show_drawer(n, o) {
      if (n) {
        this.$nextTick(()=> {
          var backdrop=document.getElementsByClassName("v-overlay__scrim")[0];
          if (backdrop)
            backdrop.addEventListener('click', this.backdropClick);
        })
      }
    }
  }
}
;
</script>

<style>
.hellgrau {
  background-color: #f2f2f2;
}

.gelb {
  background-color: #ffca37;
}

.orange {
  background-color: #ffac1b;
}

.white-bg {
  background-color: white;
}

</style>